/**
 * Created by Christal on 2018/5/15.
 * 用户相关api
 */
import * as API from './'
import querystring from 'querystring'

const OSS_AUTH_URL = '/api/back/user/getSTSSecurityKey'

export default {
  // 登录
  login: params => {
    return API.POST('/internship/front/user/login', querystring.stringify(params))
  },

  // 登出
  logout: params => {
    return API.DELETE('/internship/user/logout', params)
  },
  getOSSAuth: params => {
    return API.GET(OSS_AUTH_URL, params)
  },
  // 用户信息
  userInfo: params => {
    return API.GET('/internship/user/list', params)
  },
  // 新增用户
  userAdd: params => {
    return API.POST('/internship/user/add', querystring.stringify(params))
  },
  // 删除用户
  userDelete: params => {
    return API.DELETE('/internship/user/delete', params)
  },
  // 修改用户信息
  userUpdate: params => {
    return API.POST('/internship/users/update', params)
  },
  // 修改密码
  updPwd: params => {
    return API.POST('/internship/user/changePass', querystring.stringify(params))
  },
  // 查找所有的注册用户
  finAllUses: params => {
    return API.POST('/internship/users/finAll')
  },
  // 获取信誉信息
  findCreditInfo: params => {
    return API.GET('/api/v1/users/findUserCredit', params);
  },
  findChangeInfo: params => {
    return API.GET('/api/v1/users/promotionUser/getChangeInfo',params);
  },
  // 查找所有的注册用户
  doChangeInfo: params => {
    return API.POST('/api/v1/users/promotionUser/doChangeInfo',querystring.stringify(params));
  },
  // 获取验证码
  getCode: params => {
    return API.GET('/internship/front/user/getCode')
  }
}



// WEBPACK FOOTER //
// ./src/api/api_user.js